module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('stepbar', {
    attrs: {
      "steps": _vm.steps
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-b5d6d7c4"}!./~/.11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/pages/Stepbar.vue
// module id = 78
// module chunks = 4